import { ChainId } from '@pancakeswap/sdk'

export const SUPPORT_ONLY_BSC = [ChainId.BSC, ChainId.DOGECHAIN]
export const SUPPORT_ONLY_DC = [ChainId.BSC, ChainId.DOGECHAIN]
export const SUPPORT_FARMS = [ChainId.BSC, ChainId.BSC_TESTNET, ChainId.DOGECHAIN]
export const SUPPORT_ZAP = [ChainId.BSC, ChainId.BSC_TESTNET, ChainId.DOGECHAIN]
